import { Box, Text, Image, Grid } from '@chakra-ui/react';
import videoPlayer from '../../../assets/videoPlayer.png';
import { DashboardSection } from '../components/DashboardStyles';

export default function VarsityModules() {
    return (
        <DashboardSection>
            <Box width="100%">
                <Text
                    fontSize={{
                        base: '1.18rem',
                        sm: '1.18rem',
                        md: '1.6rem',
                        lg: '1.6rem',
                        xl: '1.6rem',
                    }}
                    marginBottom={{
                        base: '4rem',
                        sm: '4rem',
                        md: '4rem',
                        lg: '4rem',
                        xl: '2rem',
                    }}
                    fontWeight="400"
                    maxHeight=".25rem">
                    The fundamental of Selling{' '}
                    <Text opacity="0.5" display="inline">
                        (12 Paths)
                    </Text>
                </Text>
                <Box
                    maxWidth="24.4rem"
                    maxHeight="3.25rem"
                    color="#00000033"
                    border="1px solid #00000033"
                    borderRadius=".5rem"
                    display="grid"
                    gridTemplateColumns="repeat(3, 1fr)"
                    justifyItems="center"
                    alignItems="center"
                    marginBottom="1rem"
                    fontSize="xs"
                    paddingInline={{
                        base: '0',
                        sm: '.5rem',
                    }}
                    paddingBlock=".5rem">
                    {[1, 2, 3].map((item, index) => (
                        <>
                            <Text
                                key={index}
                                fontWeight="400"
                                minHeight="1.75rem"
                                maxWidth="12.313rem"
                                paddingInline=".3rem"
                                display="flex"
                                alignItems="center"
                                border="none"
                                color="#00000033"
                                _hover={{
                                    background: '#1b3b5f',
                                    color: '#ffffff',
                                    borderRadius: '.25rem',
                                }}
                                textAlign="center">
                                Module {item} (12 Courses)
                            </Text>
                        </>
                    ))}
                </Box>
                <Grid
                    gap={3}
                    autoFlow="row dense"
                    templateColumns={{
                        base: 'repeat(1, 1fr)',
                        sm: 'repeat(1, 1fr)',
                        md: 'repeat(2, 1fr)',
                        lg: 'repeat(3, 1fr)',
                    }}>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item, index) => (
                        <Grid
                            border="1px solid #d6d6d6"
                            padding="1rem"
                            borderRadius="0.625rem"
                            width="100%"
                            minHeight="9.25rem"
                            key={index}>
                            <Grid
                                gridTemplateColumns="38% 62%"
                                gridTemplateAreas='"image title" "image content"'
                                gap={3}>
                                <Image
                                    src={videoPlayer}
                                    alt=""
                                    gridArea="image"
                                    borderRadius="0.375rem"
                                    width="29.138rem"
                                    height="7rem"
                                />
                                <Text
                                    gridArea="title"
                                    fontSize={{
                                        base: '.8rem',
                                        sm: '1rem',
                                        md: '1rem',
                                        lg: '1rem',
                                        xl: '1rem',
                                    }}>
                                    Sales & Marketing <br />
                                    Lorem ipsum is them...
                                </Text>
                                <Grid
                                    gridArea="content"
                                    templateColumns={{
                                        base: 'repeat(1, 1fr)',
                                        sm: 'repeat(2, 1fr)',
                                        md: 'repeat(2, 1fr)',
                                        lg: '1fr 2fr',
                                    }}
                                    gap={3}
                                    opacity="0.5"
                                    fontSize={{
                                        base: '0.75rem',
                                        sm: '0.875rem',
                                        md: '0.875rem',
                                        lg: '0.875rem',
                                        xl: '0.875rem',
                                    }}>
                                    <Text>Beginner</Text>
                                    <Text>5hr 19m</Text>
                                </Grid>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </DashboardSection>
    );
}
